module.exports = __webpack_public_path__ + "static/media/coolgrey.f4c0d26a.png";